import {commonWebSocket} from '@services/common/common.constants';
import {createReducer} from 'redux-act';
import {IAiTask, IAnalysedImage, IEvent} from '@app-types/websocket/event.types';
import { IAiScheduleUpdate } from '@app-types/websocket/aiSchedule.types';
import * as EventActions from './event.action';

const defaultState:{  events: IEvent[], eventAnalyses:IAnalysedImage[], aiTasks: IAiTask[], aiScheduleUpdate:IAiScheduleUpdate|undefined} = {
  events: [],
  eventAnalyses: [],
  aiTasks: [],
  aiScheduleUpdate: undefined,
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

reducer
  .on(commonWebSocket.snapshot.EVENT_SNAPSHOT, (state:any, payload:any) => {
    if (Array.isArray(payload?.events))
    {
      return {
        ...state,
        events: payload.events.filter((event: any) => event && typeof event === "object" && event.id !== undefined),
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.special.EVENT_UPDATE, (state:any, payload:any) => {
    if (payload?.eventUpdate)
    {
      const newEventList = Array.isArray(state.events) ? state.events.slice() : [];
      if (Array.isArray(payload.eventUpdate.removedEvents))
      {
        for (const removeId of payload.eventUpdate.removedEvents) {
          const eventToIndex = newEventList.findIndex((event: IEvent) => {
            return event.id === removeId;
          });

          if (eventToIndex > -1)
          {
            newEventList.splice(eventToIndex, 1);
          }
        }
      }
      if (Array.isArray(payload.eventUpdate.newEvents))
      {
        for (const newEvent of payload.eventUpdate.newEvents) {
          if (newEvent && typeof newEvent === "object" && newEvent.id !== undefined) {
            newEventList.push(newEvent);
          }
        }
      }
      return {
        ...state,
        events:newEventList
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.special.AI_TASK, (state:any, payload:any) => {
    if (payload.aiTask)
    {
      let faound = false;
      const newTask = payload.aiTask;

      const doneTasks:IAiTask[] = [];
      for (const task of state.aiTasks?state.aiTasks:[]) {
        const ana:IAiTask = task;

        if (ana.startTime !== undefined && newTask.startTime < Date.now() - 1*24*60*60*1000) {
          continue; // skip old tasks
        }

        if (task.id === newTask.id) {
          faound = true;
          const updatedTask = {...ana, ...newTask}; // merge
          doneTasks.push(updatedTask);
          
        } else {
          if (ana.dismissed !== true) {
            doneTasks.push(ana);
          }
        }
      }
      

      if (!faound) {
        doneTasks.push(newTask);
      }

      return {
        ...state,
        aiTasks:doneTasks
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.special.AI_SCHEDULE_UPDATE, (state:any, payload:any) => {
    if (payload.aiScheduleUpdate)
    {
      return {
        ...state,
        aiScheduleUpdate:payload.aiScheduleUpdate
      };
    } else {
      return state;
    }
  })
  .on(commonWebSocket.special.EVENT_ANALYZE_UPDATE, (state:any, payload:any) => {
    if (payload.imageAnalysis)
    {
      let added = false;
      const newAnalysis = payload.imageAnalysis;
      const doneFileAnalyses:IAnalysedImage[] = [];
      for (const analysis of state.eventAnalyses?state.eventAnalyses:[]) {
        const ana:IAnalysedImage = analysis;

        if (ana.startTime !== undefined && newAnalysis.startTime! < Date.now() - 6*24*60*60*1000) {
          continue; // skip old analyses
        }

        if (ana.id === newAnalysis.id) {
          added = true;
          if (newAnalysis.dismissed) {
            if (newAnalysis.events === undefined) {newAnalysis.events = ana.events}
            if (newAnalysis.fileId === undefined) {newAnalysis.fileId = ana.fileId}
            if (newAnalysis.url === undefined) {newAnalysis.url = ana.url}
            if (newAnalysis.result === undefined) {newAnalysis.events = ana.result}
            if (newAnalysis.errorMsg === undefined) {newAnalysis.errorMsg = ana.errorMsg}
            if (newAnalysis.startTime === undefined) {newAnalysis.startTime = ana.startTime}
          } 
          doneFileAnalyses.push(newAnalysis);
          
        } else {
          if (ana.dismissed !== true) {
            doneFileAnalyses.push(ana);
          }
        }
      }
      

      if (!added) {
        doneFileAnalyses.push(newAnalysis);
      }

      return {
        ...state,
        eventAnalyses:doneFileAnalyses
      };
    } else {
      return state;
    }
  })
  .on(EventActions.clearAiScheduleUpdate, (state:any) => {
    return {
      ...state,
      aiScheduleUpdate: undefined
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/events/event.reducer.ts